module.exports = __webpack_public_path__ + "img/movie-img.1b494ca6.jpg";